// "Durum sayfası" next to every server-error retry (spec §11.8: server error with retry + status link): opens the
// marketing site's status page (/durum/, /en/status/ — live API health + the external status page when configured).
import { useTranslation } from 'react-i18next';
import { Icon, cx } from '@moods/ui';
import { SITE_URL } from '../../lib/env';

export const statusPageUrl = (lng: string): string => `${SITE_URL}${lng === 'en' ? '/en/status/' : '/durum/'}`;

export function StatusLink({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const { t, i18n } = useTranslation();
  return (
    <a className={cx('md-btn md-btn--ghost', size === 'sm' && 'md-btn--sm')} href={statusPageUrl(i18n.language)} target="_blank" rel="noopener noreferrer">
      {t('errors.statusLink')}
      <Icon name="external" size={16} />
    </a>
  );
}
